import Divider from './divider'
import Item from './item'
import List from './menu'
import StackedItem from './stacked-item'

export const Menu = Object.assign(List, { Item, Divider, StackedItem })
